import * as con from "../../GlobalConstants"
import { combineReducers } from "redux";
import authReducer, { logout } from '../slices/authSlice.js'
import userProfileReducer from '../slices/userProfileSlice.js'
import userLinesReducer from '../slices/userLinesSlice.js'
import modelParametersReducer from '../slices/modelParametersSlice.js'
import applicationParametersReducer from '../slices/applicationParametersSlice.js'
import marketValuesReducer from '../slices/marketValuesSlice.js'
import advisorsReducer from '../slices/advisorsSlice.js'
import transactionsReducer from '../slices/transactionsSlice.js'
import userLineApplicationParametersReducer from '../slices/userLineApplicationParametersSlice.js'
import scenariosReducer from '../slices/scenariosSlice.js'
import surrogateUserTransactionsReducer from '../slices/surrogateUserTransactionsSlice.js'
import gridStrategyReducer from '../slices/gridSlice.js'


const appReducer = combineReducers({
    [con.REDUCER_AUTHENTICATION]: authReducer,
    [con.REDUCER_USER_PROFILE]: userProfileReducer,
    [con.REDUCER_USER_LINES]: userLinesReducer,
    [con.REDUCER_MODEL_PARAMETERS]: modelParametersReducer,
    [con.REDUCER_APPLICATION_PARAMETERS]: applicationParametersReducer,
    [con.REDUCER_MARKET_VALUES]: marketValuesReducer,
    [con.REDUCER_ADVISORS]: advisorsReducer,
    [con.REDUCER_TRANSACTIONS]: transactionsReducer,
    [con.REDUCER_USER_LINE_APPLICATION_PARAMETERS]: userLineApplicationParametersReducer,
    [con.REDUCER_SCENARIOS]: scenariosReducer,
    [con.REDUCER_SURROGATE_USERS_TRANSACTIONS]: surrogateUserTransactionsReducer,
    [con.REDUCER_GRID_STRATEGY]: gridStrategyReducer,

})

const rootReducer = (state, action) => {
  if (action.type === logout.fulfilled.type) {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer